export default {
  getDocument: (state) => (id) => state.documents.find((d) => d.id === id),
  getFileUrl: () => (id) => `${process.env.VUE_APP_APIURL}/files/${id}`,
  getNewDocuments: (state) => state.documents.filter((d) => !d.isProcessed),
  getProcessedDocuments: (state) => state.documents.filter((d) => d.isProcessed),
};
